import { downgradeInjectable } from '@angular/upgrade/static';
import { ChartFacade } from '@mode/charts/contract';
import { VizDesignerFacade } from '@mode/charts/domain';
import { ChartExportFacade } from '@mode/file-exports/domain';
import * as angular from 'angular';

export const DowngradedChartsDomainModule = angular
  .module('downgraded-charts-domain', [])
  .service('ChartFacade', downgradeInjectable(ChartFacade))
  .service('ChartExportFacade', downgradeInjectable(ChartExportFacade))
  .service('VizDesignerFacade', downgradeInjectable(VizDesignerFacade)).name;
